"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationError = void 0;
var tslib_1 = require("tslib");
var genericError_js_1 = require("./genericError.js");
/**
 * Ошибка конфигурации. Должна использоваться при конфигурации чего-либо.
 *
 * @example
 * const val = config.get('val');
 *
 * if (!val) {
 *  throw new ConfigurationError({ message: 'Configuration error!', domain: 'Foo#constructor' });
 * }
 *
 * @export
 * @class ConfigurationError
 * @extends {GenericError}
 */
var ConfigurationError = /** @class */ (function (_super) {
    tslib_1.__extends(ConfigurationError, _super);
    function ConfigurationError(_a) {
        var message = _a.message, domain = _a.domain, details = _a.details;
        var _this = _super.call(this, {
            type: 'ConfigurationError',
            message: message,
            domain: domain,
            details: details,
        }) || this;
        Object.setPrototypeOf(_this, ConfigurationError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ConfigurationError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return ConfigurationError;
}(genericError_js_1.GenericError));
exports.ConfigurationError = ConfigurationError;
//# sourceMappingURL=configurationError.js.map